// extracted by mini-css-extract-plugin
export default {"create__user_modal_body":"tableList_create__user_modal_body__G3x5S"};